import { CONSENT_POPUP_WINDOW_NAMES } from '@shared/constants';

// True when the current window is one of our consent popups. window.open() sets the tab's name, and
// window.name survives the cross-origin round trip through the Palary consent page, so it is still
// set once the popup lands back on our consent-callback route. Used to keep app-wide side effects
// (notably AuthInitializer's token refresh) out of that throwaway popup, whose sessionStorage is a
// copy of the opener's and would otherwise rotate the shared refresh token.
export const isConsentPopupWindow = () =>
	typeof window !== 'undefined' && CONSENT_POPUP_WINDOW_NAMES.includes(window.name);
